import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.function.name";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';

/**
 * Component to collect a memorable date (such as a birth date) from a user.
 *
 * An element must be passed in as the legend, commonly a header <h1-h6>.
 *
 * Default behavior is to accept any date. Passing a Date into initialDate
 * and/or latestDate will limit acceptable input.
 *
 * Similarly, an initial Date can be passed in via the initialDate property.
 *
 * All Dates should have a time representing midnight UTC.
 *
 * onlyAllowPast: If true, will only accept yesterday or earlier for a date.
 * onlyAllowFuture: If true, will only accept tomorrow or later for a date.
 * includeToday: If true, onlyAllowFuture will accept today for a date.
 *
 * Whenever the date is updated, this.props.handleDate is called.
 *
 * This component works exclusively in UTC due to bugs / inconsistencies in how
 * browsers handle daylight savings time in the past. E.g., Safari creates
 * midnight 4/10/57 should be as 4am UTC but (correctly) displays it assuming a
 * -500 offset.
 *
 * Inspired by https://design-system.service.gov.uk/components/date-input/
 */
var MemorableDateInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MemorableDateInput, _React$Component);

  // Used to ensure unique ids if multiple inputs are in use at once.
  function MemorableDateInput(props) {
    var _this;

    _classCallCheck(this, MemorableDateInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MemorableDateInput).call(this, props));
    _this.earliest = void 0;
    _this.latest = void 0;
    _this.initial = void 0;
    _this.componentId = void 0;
    _this.timeout = void 0;

    _this.handleFocus = function () {
      clearTimeout(_this.timeout);

      _this.setState({
        hasFocus: true
      });
    };

    _this.handleBlur = function () {
      _this.timeout = setTimeout(function () {
        var fields = _this.state.fields; // This has the effect of normalizing dates. So, for example, February
        // 31st will get changed to March 3rd. We do this only onBlur so that we
        // don’t disturb inputs if people temporarily make invalid dates while
        // editing.

        if (!inputCompleteError(fields)) {
          var date = fieldsToDate(fields, _this.props.modDateTime);
          fields = dateToFields(date);
        }

        _this.setState({
          fields: fields,
          hasFocus: false,
          dirty: true
        });
      }, 0);
    };

    _this.handleChange = function (event) {
      _this.updateFields(_objectSpread({}, _this.state.fields, _defineProperty({}, event.target.name, event.target.value)));
    };

    _this.componentId = props.componentId ? props.componentId : new Date().getTime().toString();
    _this.initial = props.initialDate || null;
    checkIfPropsValid(props);
    _this.earliest = returnLimitAsDate(props.earliestDate, !!props.onlyAllowFuture);
    _this.latest = returnLimitAsDate(props.latestDate, !!props.onlyAllowPast);
    _this.state = {
      hasFocus: false,
      dirty: !!_this.initial,
      lastValidityError: _this.initial && _this.isDateValid(_this.initial),
      fields: _this.setFields(_this.initial)
    };
    return _this;
  }

  _createClass(MemorableDateInput, [{
    key: "setFields",
    value: function setFields(date) {
      if (date) {
        return dateToFields(date);
      } else {
        return {
          year: '',
          month: '',
          day: ''
        };
      }
    }
    /**
     * Uses the UTC values of a Date to format in en-US locale.
     */

  }, {
    key: "isDateValid",

    /**
     * Helper to call isDateValid with all of our constraint props filled in.
     */
    value: function isDateValid(date) {
      return dateValidError(date, this.earliest, this.latest, this.props.onlyAllowPast, this.props.onlyAllowFuture, this.props.includeToday);
    }
    /**
     * Called when the fields change to update state. Calls the handleDate prop
     * with either a valid date or null.
     *
     * Also updates the lastValidityError state so we can keep error messages
     * around while the user edits.
     */

  }, {
    key: "updateFields",
    value: function updateFields(fields) {
      var _this2 = this;

      var date;
      var lastValidityError;

      if (inputCompleteError(fields)) {
        date = null; // We don't reset the validity error if the user hasn’t typed in a new
        // date. This lets us show the date constraints while they’re editing.

        lastValidityError = this.state.lastValidityError;
      } else {
        date = fieldsToDate(fields, this.props.modDateTime);
        lastValidityError = this.isDateValid(date);

        if (lastValidityError) {
          date = null;
        }
      }

      this.setState({
        fields: fields,
        lastValidityError: lastValidityError
      }, function () {
        _this2.props.handleDate(date);
      });
    } // For the purposes of gracefully showing/hiding error text, we want to track
    // focus/blur across all three fields in order to treat this component itself
    // as having a focus and a blur state.

  }, {
    key: "currentError",

    /**
     * Returns the current error message to show.
     *
     * Here’s the algorithm:
     *  - Show "missing input" errors only if we’ve focused in the past (dirty)
     *    and are not currently focusing (hasFocus)
     *  - If we’re focused, show errors relating to the validity of the
     *    currently-entered date
     *  - If we’re focused (the user is editing), the validity error should be
     *    sticky if there are missing inputs
     */
    value: function currentError() {
      var _this$state = this.state,
          fields = _this$state.fields,
          dirty = _this$state.dirty,
          hasFocus = _this$state.hasFocus,
          lastValidityError = _this$state.lastValidityError;
      var missingInputError = inputCompleteError(fields);
      if (this.props.disabled) return null;

      if (missingInputError) {
        if (!hasFocus && dirty) {
          return missingInputError;
        } else if (hasFocus) {
          return lastValidityError;
        } else {
          return null;
        }
      } else {
        return lastValidityError;
      }
    }
    /**
     * Reset date fields to original values if provided, or clear all fields.
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (!prevProps.resetDate && this.props.resetDate) {
        this.setState({
          fields: this.setFields(null)
        }, function () {
          _this3.setState({
            dirty: false
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var inputAttributes = {
        type: 'number',
        className: 'txt-f',
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      };
      var legend = this.props.legend;
      var error = this.currentError();

      var legendElem = function legendElem() {
        var style = {
          width: '100%'
        };

        if (_this4.props.hideLengend) {
          style['display'] = 'none';
        }

        if (legend) {
          return jsx("legend", {
            style: style
          }, legend);
        } else {
          return jsx("span", null);
        }
      };

      var content = function content() {
        return jsx("div", null, legend && legendElem(), jsx("div", {
          css: FIELDS_CONTAINER_STYLING,
          className: _this4.props.disabled ? 'disabled' : ''
        }, jsx("div", null, jsx("label", {
          htmlFor: "".concat(_this4.componentId, "-month"),
          className: "txt-l"
        }, "Month"), jsx("input", _extends({}, inputAttributes, {
          id: "".concat(_this4.componentId, "-month"),
          name: "month",
          min: "1",
          max: "12",
          placeholder: "MM",
          value: _this4.state.fields.month,
          disabled: _this4.props.disabled,
          maxLength: 2
        }))), jsx("div", null, jsx("label", {
          htmlFor: "".concat(_this4.componentId, "-day"),
          className: "txt-l"
        }, "Day"), jsx("input", _extends({}, inputAttributes, {
          id: "".concat(_this4.componentId, "-day"),
          name: "day",
          min: "1",
          max: "31",
          placeholder: "DD",
          value: _this4.state.fields.day,
          disabled: _this4.props.disabled,
          maxLength: 2
        }))), jsx("div", null, jsx("label", {
          htmlFor: "".concat(_this4.componentId, "-year"),
          className: "txt-l"
        }, "Year"), jsx("input", _extends({}, inputAttributes, {
          id: "".concat(_this4.componentId, "-year"),
          name: "year",
          min: _this4.earliest ? _this4.earliest.getUTCFullYear() : '1000',
          max: _this4.latest ? _this4.latest.getUTCFullYear() : '9999',
          placeholder: "YYYY",
          value: _this4.state.fields.year,
          disabled: _this4.props.disabled,
          maxLength: 4
        })))), error && jsx("div", {
          className: "t--err m-t200"
        }, error));
      };

      var wFieldset = function wFieldset() {
        return jsx("fieldset", {
          css: FIELDSET_STYLING
        }, content());
      };

      var returnElem = function returnElem() {
        if (_this4.props.sansFieldset) {
          return content();
        } else {
          return wFieldset();
        }
      };

      return returnElem();
    }
  }], [{
    key: "formattedDateUtc",
    value: function formattedDateUtc(date) {
      return "".concat(date.getUTCMonth() + 1, "/").concat(date.getUTCDate(), "/").concat(date.getUTCFullYear());
    }
  }]);

  return MemorableDateInput;
}(React.Component);
/**
 * This function is intended to provide developer support by ensuring
 * the properties passed into the component are valid.
 *
 * Thrown errors are left uncaught to call attention to the fact!
 */


export { MemorableDateInput as default };

function checkIfPropsValid(props) {
  var todayTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
  var earliestDateTime = props.earliestDate ? new Date(props.earliestDate).getTime() : null;
  var latestDateTime = props.latestDate ? new Date(props.latestDate).getTime() : null; // yesterdayTime and tomorrowTime are both true

  if (props.onlyAllowPast && props.onlyAllowFuture) {
    throw new Error('onlyAllowPast and onlyAllowFuture can’t BOTH be true!');
  }

  if (earliestDateTime) {
    // earliestTime is the same or later date than latestTime
    if (latestDateTime && earliestDateTime >= latestDateTime) {
      throw new Error("earliestDate must come before latestDate.\n        Received: earliestDate: ".concat(props.earliestDate, " latestDate: ").concat(props.latestDate)); // onlyAllowPast is true, but earliestTime is today or later
    } else if (props.onlyAllowPast && earliestDateTime >= todayTime) {
      throw new Error("When onlyAllowPast is true, earliestDate must be yesterday or earlier.\n          \n          Received: earliestDate: ".concat(props.earliestDate)); // onlyAllowFuture is true, but earliestTime is tomorrow or earlier
    } else if (props.onlyAllowFuture && earliestDateTime <= todayTime) {
      throw new Error("When onlyAllowFuture is true, earliestDate must be tomorrow or later.\n        \n        Received: earliestDate: ".concat(props.earliestDate));
    }
  }

  if (latestDateTime) {
    // onlyAllowPast is true, but latestTime is today or later
    if (props.onlyAllowPast && latestDateTime >= todayTime) {
      throw new Error("When onlyAllowPast is true, latestDate must be yesterday or earlier.\n        Received: latestDate: ".concat(props.latestDate)); // onlyAllowFuture is true, but latestTime is today or earlier
    } else if (props.onlyAllowFuture && latestDateTime <= todayTime) {
      throw new Error("When onlyAllowFuture is true, latestDate must be tomorrow or later.\n        Received: latestDate: ".concat(props.latestDate));
    }
  }
} // Determine upper or lower limit date, if applicable.


export function returnLimitAsDate(suppliedDate) {
  var hasRelativeLimitation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var date = // We clone so that we can mutate it below
  suppliedDate && new Date(suppliedDate) || hasRelativeLimitation && new Date() || null;

  if (date) {
    date.setUTCHours(0, 0, 0, 0);
  }

  return date;
}
/**
 * Returns an error string if user input is incomplete, or if the
 * values are definitely out-of-bounds.
 *
 * isDateValid tests them against the validity constraints.
 */

export function inputCompleteError(fields) {
  // Check for negative values in fields and resets them.
  for (var _i = 0, _Object$keys = Object.keys(fields); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];

    if (fields[key] < 0) {
      fields[key] = fields[key] * -1;
    }
  }

  var month = fields.month,
      day = fields.day,
      year = fields.year;
  var missingFields = [];
  var monthInt = parseInt(month, 10);
  var dayInt = parseInt(day, 10);
  var yearInt = parseInt(year, 10);
  var errorString = null;

  if (isNaN(monthInt) || monthInt <= 0 || monthInt > 12) {
    missingFields.push('month');
  }

  if (isNaN(dayInt) || dayInt <= 0 || dayInt > 31) {
    missingFields.push('day');
  }

  if (isNaN(yearInt) || year.length !== 4) {
    missingFields.push('year');
  } // One field has been skipped


  if (missingFields.length === 1) {
    errorString = "Date must include the ".concat(missingFields[0]); // Only one field has user input
  } else if (missingFields.length === 2) {
    errorString = "Date must include the ".concat(missingFields[0], " and ").concat(missingFields[1]); // All fields missing
  } else if (missingFields.length === 3) {
    errorString = 'Please enter a date';
  }

  return errorString;
}
/**
 * Returns useful error string if a given date is not valid.
 */

export function dateValidError(date, earliest, latest) {
  var onlyAllowPast = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var onlyAllowFuture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var includeToday = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var dateTime = date.getTime(); // We grab this to get the browser’s assumption of the current date.

  var todayLocal = new Date(); // Convert to the UTC equivalent of today’s date.

  var todayTime = Date.UTC(todayLocal.getFullYear(), todayLocal.getMonth(), todayLocal.getDate()); // If onlyAllowFuture needs to include the current day

  /**
   * Used to validate if the date passed s greater than the current date (after subtracting one day). This is dones to include the current day.
   * Returns a boolean for whether to use `onlyAllowFuture`.
   */

  var allowFuture = function allowFuture() {
    var _todayLocal = new Date(new Date().setDate(new Date().getDate() - 1));

    var _todayTime = Date.UTC(_todayLocal.getFullYear(), _todayLocal.getMonth(), _todayLocal.getDate());

    if (includeToday && includeToday === true && onlyAllowFuture && onlyAllowFuture === true) {
      return dateTime > _todayTime;
    } else {
      return dateTime > todayTime;
    }
  }; // success conditions for each limiting attribute:


  var passes = {
    onlyAllowPast: dateTime < todayTime,
    onlyAllowFuture: allowFuture(),
    earliest: earliest && dateTime > earliest.getTime(),
    latest: latest && dateTime < latest.getTime()
  };
  var errorString = '';

  if (onlyAllowPast) {
    if (!passes.onlyAllowPast) {
      errorString = 'The date must be from the past';
    } else if (earliest && !passes.earliest) {
      errorString = "The date must be between ".concat(MemorableDateInput.formattedDateUtc(earliest), " and today");
    }
  } else if (onlyAllowFuture) {
    if (!passes.onlyAllowFuture) {
      errorString = 'The date must be in the future';
    } else if (latest && !passes.latest) {
      errorString = "The date must be between today and ".concat(MemorableDateInput.formattedDateUtc(latest));
    } // if earlier and later are both specified, date must fall between the two.

  } else if (earliest && latest && !(passes.earliest && passes.latest)) {
    errorString = "The date must fall between ".concat(MemorableDateInput.formattedDateUtc(earliest), " and ").concat(MemorableDateInput.formattedDateUtc(latest));
  } else if (earliest && !passes.earliest) {
    errorString = "The date must be later than ".concat(MemorableDateInput.formattedDateUtc(earliest));
  } else if (latest && !passes.latest) {
    errorString = "The date must be earlier than ".concat(MemorableDateInput.formattedDateUtc(latest));
  }

  return errorString;
}

function fieldsToDate(_ref, modDateTime) {
  var year = _ref.year,
      month = _ref.month,
      day = _ref.day;
  var retDate = new Date(Date.UTC(+year, +month - 1, +day));

  if (modDateTime && modDateTime === true) {
    retDate = new Date(new Date(Date.UTC(+year, +month - 1, 1 + +day)).setHours(0, 0, 0, 0));
  }

  return retDate;
}

function dateToFields(date) {
  return {
    year: date.getUTCFullYear().toString(),
    month: (date.getUTCMonth() + 1).toString(),
    day: date.getUTCDate().toString()
  };
}

var FIELDSET_STYLING = css({
  border: 'none',
  padding: 0,
  margin: 0,
  legend: {
    paddingLeft: 0,
    fontSize: '120%'
  }
});
var FIELDS_CONTAINER_STYLING = css({
  display: 'flex',
  justifyContent: 'space-between',
  transition: 'opacity 0.1s',
  '> div': {
    flex: '0 0 24%',
    '&:last-of-type': {
      flex: '0 0 50%'
    }
  },
  input: {
    MozAppearance: 'textfield',
    '&::-webkit-inner-spin-button': {
      WebkitAppearance: 'none'
    },
    '&::-ms-clear': {
      display: 'none'
    }
  },
  label: {
    marginTop: '0.5rem'
  },
  '&.disabled': {
    opacity: 0.4,
    '*': {
      cursor: 'not-allowed'
    }
  }
});